import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,addClass,hasClass,on,findIn} from '@elements/dom-utils';
import {translate} from '@elements/translations';
import {clearAll} from "@elements/alert-notification";

const selectors = {
    base: '.js-show-more',
    btn: '.js-show-more__btn',
    text: '.js-show-more__text',
    accordion: '.js-show-more__accordion'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let btn = findIn(selectors.btn, baseElement);
        let text = findIn(selectors.text, baseElement);
        let accordion = findIn(selectors.accordion, baseElement);

        if (btn){
            if(btn.getAttribute("data-has-accordion") && btn.getAttribute("data-accordions") <= 3){
                addClass("d-none", btn)
            }

            on("click", function () {
                //show rest of accordions
                if(btn.getAttribute("data-has-accordion")){
                    if (hasClass('open', btn)) {
                        addClass('hide-accordion', accordion);
                        removeClass('open', btn);
                        btn.innerHTML = translate('accordion.show-more');
                    } else {
                        removeClass('hide-accordion', accordion);
                        addClass('open', btn);
                        btn.innerHTML = translate('accordion.show-less');
                    }
                }else {
                    //normal wysiwy show more
                    if (hasClass('open', btn)) {
                        addClass('hide-content', text);
                        removeClass('show-content', text);
                        removeClass('open', btn);
                        btn.innerHTML = translate('wysiwyg.show-more');

                        //scroll to top
                        setTimeout(() => {
                            baseElement.scrollIntoView({behavior: "smooth"});
                        }, 100);

                    } else {
                        removeClass('hide-content', text);
                        addClass('show-content', text);
                        addClass('open', btn);
                        btn.innerHTML = translate('wysiwyg.show-less');
                    }
                }
            }, btn);
        }
    });
}
